"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestRemoveGamblerSettings = exports.requestAddGamblerSettings = void 0;
var constants_1 = require("./constants");
var actions_1 = require("./actions");
var selectors_1 = require("./selectors");
var requestAddGamblerSettings = function (actions$, store) {
    return actions$.ofType(constants_1.ADD_FAVORITE_MARKET_ACTION).map(function (action) {
        var state = store.getState();
        var favoriteMarkets = selectors_1.selectFavoriteMarketsId(state);
        var _a = action.payload, sportId = _a.sportId, marketTemplateId = _a.marketTemplateId;
        if (favoriteMarkets) {
            favoriteMarkets[sportId] = __spreadArray(__spreadArray([], (favoriteMarkets[sportId] || [])), [
                marketTemplateId,
            ]);
        }
        return actions_1.addFavoriteMarkets(JSON.stringify(favoriteMarkets));
    });
};
exports.requestAddGamblerSettings = requestAddGamblerSettings;
var requestRemoveGamblerSettings = function (actions$, store) {
    return actions$.ofType(constants_1.REMOVE_FAVORITE_MARKET_ACTION).map(function (action) {
        var state = store.getState();
        var favoriteMarketsId = selectors_1.selectFavoriteMarketsId(state);
        var _a = action.payload, sportId = _a.sportId, marketTemplateId = _a.marketTemplateId;
        var favorites = favoriteMarketsId && favoriteMarketsId[sportId];
        favoriteMarketsId[sportId] = favorites
            ? favorites.filter(function (id) { return id !== marketTemplateId; })
            : [];
        return actions_1.addFavoriteMarkets(JSON.stringify(favoriteMarketsId));
    });
};
exports.requestRemoveGamblerSettings = requestRemoveGamblerSettings;
//# sourceMappingURL=epics.js.map